import React, { Component } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import adminApi, { AdminSignInRequest } from '../../apis/admin.api'
import storageService from '../../services/storage.service'
import adminRoutes from '../../routes/adminRoutes'
import Page from '../../components/Page'
import SignInCard from '../../components/SignInCard'

interface SignInProps extends RouteComponentProps {}

interface SignInState {
  username: string
  password: string
}

class SignIn
  extends Component<SignInProps, SignInState> {
  constructor (props: SignInProps) {
    super(props)
    this.state = {
      username: '',
      password: '',
    }
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleSignInClick = this.handleSignInClick.bind(this)
  }

  signIn () {
    const { username, password } = this.state
    const payload: AdminSignInRequest = {}
    if (username) payload.username = username
    if (password) payload.password = password
    adminApi.signIn(payload, data => {
      if (!data) return
      storageService.set('authToken', data.token)
      this.props.history.push(adminRoutes.subscribers)
    })
  }

  handleInputChange (name: string, value: string) {
    if (name === 'username') this.setState({ username: value })
    if (name === 'password') this.setState({ password: value })
  }

  handleSignInClick () {
    this.signIn()
  }

  render () {
    return (
      <Page size='half' wrapperClass="pt-20">
        <SignInCard
          heading="QPRO+ Admin"
          username={this.state.username}
          password={this.state.password}
          progress={false}
          onInputChange={this.handleInputChange}
          onSignInClick={this.handleSignInClick}>
        </SignInCard>
      </Page>
    )
  }
}

export default withRouter(SignIn)
